const getMembershipPlanLabel = (plan_key) => ['super-hero', 'test-super-hero'].includes(plan_key)
    ? 'SH'
    : ['basic', 'test-basic'].includes(plan_key)
        ? 'EH'
        : null;
export default getMembershipPlanLabel;
